import { CSSProperties, useState } from "react";
import { FaPenSquare } from "react-icons/fa";

export const XUpdatableInput = ({
  value,
  onChange,
  style,
}: {
  value: string;
  onChange?: (value: string) => void;
  style?: CSSProperties;
}) => {
  const [isModified, setModified] = useState(false);
  const [modifiedValue, setModifiedValue] = useState(value);

  const onValidateChange = () => {
    setModified(false);
    onChange?.(modifiedValue);
  };

  if (isModified) {
    return (
      <input
        autoFocus
        value={modifiedValue}
        onChange={(event) => setModifiedValue(event.target.value)}
        onBlur={onValidateChange}
        onKeyDown={(event) => {
          if (event.key.toLowerCase().includes("enter")) {
            onValidateChange();
          }
        }}
        style={style}
      />
    );
  } else {
    return (
      <p style={style}>
        {value}
        <FaPenSquare
          style={{
            verticalAlign: "middle",
            marginLeft: 4,
            cursor: "pointer",
          }}
          onClick={() => {
            setModifiedValue(value);
            setModified(true);
          }}
        />
      </p>
    );
  }
};
